import { cn } from '@/lib/utils'

export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger'

/**
 * Los tonos success y danger usan un texto MÁS OSCURO que el --success /
 * --danger originales. Medido sobre la app desplegada, esos badges quedaban en
 * 3.86:1 y 4.43:1, por debajo del 4.5:1 que exige WCAG AA para texto pequeño.
 */
const TONES: Record<Tone, string> = {
  neutral: 'bg-secondary text-secondary-foreground',
  info: 'bg-primary-muted text-accent-foreground',
  success: 'bg-success-muted text-[oklch(45%_0.14_155)]',
  warning: 'bg-warning-muted text-warning-foreground',
  danger: 'bg-danger-muted text-[oklch(45%_0.19_27)]',
}

/** Mapa completo de los estados observados en la app original. */
const STATUS_TONE: Record<string, Tone> = {
  // Vehículos
  Active: 'success',
  'In Repair': 'warning',
  'Out of Service': 'danger',
  Sold: 'neutral',
  Retired: 'neutral',
  // Inspecciones
  Passed: 'success',
  'Passed With Issues': 'warning',
  Failed: 'danger',
  Good: 'success',
  Attention: 'warning',
  Repair: 'danger',
  'Not Applicable': 'neutral',
  // Órdenes de trabajo
  Reported: 'danger',
  Scheduled: 'info',
  'In Progress': 'info',
  'Waiting for Parts': 'warning',
  'Waiting for Approval': 'warning',
  Completed: 'success',
  Cancelled: 'neutral',
  // Prioridad
  Low: 'neutral',
  Normal: 'info',
  High: 'warning',
  Critical: 'danger',
  // Mantenimiento
  OK: 'success',
  'Due Soon': 'warning',
  Overdue: 'danger',
}

export function toneFor(status: string): Tone {
  return STATUS_TONE[status] ?? 'neutral'
}

export function StatusPill({
  status,
  tone,
  className,
}: {
  status: string
  tone?: Tone
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONES[tone ?? toneFor(status)],
        className,
      )}
    >
      {status}
    </span>
  )
}
